import { Container } from 'react-bootstrap';
import CopyrightPPLink from './CopyrightPPLink';
import Links from './Links';

const Footer = ({className}: any) => {
    return (
        <footer className={`footer ${className && className}`}>
            <Container>
                <div className='page-links text-center'>
                    <Links/>
                </div>
            </Container>
            <hr style={{ margin: 0 }} />
            <CopyrightPPLink/>
        </footer>
    );
};

export default Footer;
